const Colors = {
    blue: '#00338C',
    green: '#B7B900',
    white: '#FFFFFF',
    tanDark: '#EFD4AE',
    tanLight: '#FFFBF2',
    black: '#000000',
    red: '#ea0000',

    goldDark: '#BD9E47',
    goldLight: '#E4CA81',
    grayDark: '#2D2D2D',
    grayMedium: '#454545',
};

export default Colors;